module.exports = "/rate/components/starRating-84814b.html";